export default __webpack_public_path__ + "assets/models/97eb1e69ff0e2928fe56b46e61217196.glb";